import React from 'react'
import { Grid } from 'semantic-ui-react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import { translate } from 'loankeeper-common/helpers'
//@ts-ignore
import LKPrintButton, { constants as LKPrintButtonConstants } from 'shared/LKPrintButton'
import { withConstantPermissions } from 'shared'
import { getOrderAddFlags, setOrderAddFlags } from '../helpers'
import FormField from '../../shared/newFormElements'
import { GridContainer } from '../../shared/StyledComponents'
import { PrintOptionsProps } from './types'

const RadioGroupWrapper = styled.div`
  .lk-radio {
    margin-left: 15px;

    &:first-child {
      margin-left: 30px;
    }
  }
`

const printPagesByOperType = {
  1: 'printmemorder',
  3: 'printcashin',
  4: 'printcashout',
  6: 'printconvacc',
  7: 'printconvcash',
}

//@ts-ignore
@withConstantPermissions('ACC_ENTRIES_VIEW as CanViewACC')
//@ts-ignore
@connect((state, { FormName }) => ({
  print: formValueSelector(FormName)(state, 'print'),
  printOption: formValueSelector(FormName)(state, 'printOption'),
  visible: formValueSelector(FormName)(state, 'action') === 'add',
}))
class PrintOptions extends React.Component<PrintOptionsProps> {
  componentDidMount() {
    const { FormName, visible, CanViewACC } = this.props

    if (visible && CanViewACC) {
      const orderAddFlags = getOrderAddFlags(FormName)
      if (orderAddFlags[FormName].print) {
        this.props.change('print', orderAddFlags[FormName].print)
      }

      if (orderAddFlags[FormName].printOption) {
        this.props.change('printOption', orderAddFlags[FormName].printOption)
      }
    }
  }

  componentWillUnmount() {
    const { FormName, visible, print, printOption } = this.props

    if (visible) {
      const flagsState = getOrderAddFlags(FormName)

      flagsState[FormName].print = print || '0'
      flagsState[FormName].printOption = printOption

      setOrderAddFlags(flagsState)
    }
  }

  handleCheckboxChange = (checked: boolean) => {
    if (checked) {
      if (!this.props.printOption) {
        this.props.change('printOption', '1')
      }
    }
  }

  printOptions = [
    { value: '1', label: translate('frm_acc_entry_add-rb_print') },
    { value: '2', label: translate('frm_acc_entry_add-rb_preview') },
    { value: '3', label: translate('frm_acc_entry_add-rb_showdetails') },
  ]

  render() {
    const { visible, CanViewACC, print, printOption, ID, hash, OperTypeID, OID, OIDHash } = this.props
    console.log(visible)
    return visible ? (
      <GridContainer>
        <Grid>
          <Grid.Row columns={1}>
            {CanViewACC && (
              <>
                {/* @ts-ignore */}
                <FormField
                  name="print"
                  customOnChange={this.handleCheckboxChange}
                  type="checkbox"
                  label={translate('frm_acc_entry_add-cmd_print_now')}
                />
                {print === '1' && (
                  <RadioGroupWrapper>
                    {/* @ts-ignore */}
                    <FormField
                      type="radio"
                      name="printOption"
                      selectedValue={printOption}
                      options={this.printOptions}
                    />
                  </RadioGroupWrapper>
                )}
              </>
            )}
          </Grid.Row>
        </Grid>
      </GridContainer>
    ) : (
      <GridContainer>
        <Grid>
          <Grid.Row columns={1}>
            <Grid.Column textAlign="right">
              <LKPrintButton
                direct
                type={LKPrintButtonConstants.types.entry}
                name={translate('frm_acc_entry_add-cmd_print_now')}
                ID={ID}
                hash={hash}
                page={printPagesByOperType[OperTypeID]}
                extraParams={{ OID, HashSum_OID_: OIDHash }}
                leftward
                upward
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </GridContainer>
    )
  }
}

export default PrintOptions
